export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Admissions", to: "/admissions" },
  { label: "Partners & Referrals", to: "/partners" },
  { label: "Donate", to: "/donate" },
  { label: "Contact", to: "/contact" },
  { label: "Resources", to: "/resources" },
  { label: "Accountability", to: "/accountability" },
];

export const IMAGES = {
  heroSupport: "/hero-support-v4.jpg",
  heroFacility: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  buildingWide: "https://images.unsplash.com/photo-1614595737683-1740e41bfaac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  portrait: "https://images.unsplash.com/photo-1624395213081-608f51284ddd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  portraitAlt: "https://images.unsplash.com/photo-1617037252429-4c494158e481?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  housing: "https://images.unsplash.com/photo-1644955052489-10bda5c94b19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  retreat: "https://images.unsplash.com/photo-1566231270035-0aaca1fd2bbf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  community: "https://images.unsplash.com/photo-1507537362848-9c7e70b7b5c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const TRUST_STRIP = [
  "Veteran-focused",
  "Transitional housing",
  "Case management",
  "Community partnerships",
  "Trauma-informed care",
];

export const HERO_TRUST = ["24/7 Intake Assistance", "100% Drug & Alcohol Free", "Zero Cost To Veterans"];

export const PROGRAMS = [
  {
    id: "transitional-housing",
    num: "01",
    icon: "home",
    title: "Transitional Reset Housing",
    desc: "A clean, secure, alcohol- and drug-free residential facility offering semi-private accommodations, daily nutritious meals, laundry facilities, and round-the-clock staffing to help veterans stabilize from crisis.",
  },
  {
    id: "reset-wellness",
    num: "02",
    icon: "heart-pulse",
    title: "Reset & Recovery Support",
    desc: "Holistic stabilization incorporating peer-led support groups, trauma-informed wellness counseling, physical fitness activities, and stress-management coaching designed specifically for military transitions.",
  },
  {
    id: "referrals",
    num: "03",
    icon: "file-text",
    title: "Benefits & VA Navigation",
    desc: "Expert guidance through complex federal, state, and non-profit benefit systems. Our Veteran Service Officers help veterans file disability claims, enroll in VA healthcare, and secure state entitlements.",
  },
  {
    id: "reintegration",
    num: "04",
    icon: "briefcase",
    title: "Reintegration & Career Pathway",
    desc: "Focused skill-building to bridge military experience with sustainable civilian employment and independent housing. Includes resume building, interview practice, local employer partnerships, and lease preparation.",
  },
];

export const PROGRAM_SECTIONS = [
  {
    id: "transitional-housing",
    num: "01",
    title: "Transitional Housing",
    body: "Safe, dignified rooms in a structured residence. Each veteran gets a stable place to stay while a longer-term housing path is built. We keep it calm, clean, and predictable — recovery needs a foundation, not chaos.",
    points: ["Private, secure rooms", "Structured daily rhythm", "Shared common spaces", "Quiet, disciplined environment"],
    image: IMAGES.housing,
  },
  {
    id: "reset-wellness",
    num: "02",
    title: "Reset & Wellness Support",
    body: "A deliberate pause. Trauma-informed support, routine, rest, and access to care that helps a veteran stabilize mentally and physically before making major decisions.",
    points: ["Trauma-informed approach", "Daily structure & routine", "Access to health referrals", "Peer connection"],
    image: IMAGES.retreat,
  },
  {
    id: "case-management",
    num: "03",
    title: "Case Management",
    body: "Every veteran is paired with a case manager who owns the plan. We track goals, appointments, and paperwork so nothing falls through the cracks.",
    points: ["Dedicated case manager", "Personal stabilization plan", "Goal & progress tracking", "Advocacy across systems"],
    image: IMAGES.community,
  },
  {
    id: "referrals",
    num: "04",
    title: "VA & Community Referrals",
    body: "We connect veterans to the wider network — VA benefits, healthcare, legal aid, employment services, and local partners — and follow up to make sure the connection sticks.",
    points: ["VA benefits coordination", "Healthcare connections", "Employment & legal aid", "Warm hand-offs, not cold lists"],
    image: IMAGES.buildingWide,
  },
  {
    id: "reintegration",
    num: "05",
    title: "Reintegration Planning",
    body: "The goal is forward. We build a realistic path toward permanent housing, stable income, and community — so leaving Iron Shield means moving up, not out.",
    points: ["Permanent housing path", "Income & stability planning", "Community reintegration", "Ongoing check-ins"],
    image: IMAGES.heroFacility,
  },
];

export const HOW_IT_WORKS = [
  {
    num: "01",
    phase: "Phase 1",
    title: "Referral & Immediate Screening",
    desc: "Veteran or referral partner connects via form or call. A rapid 15-minute phone intake verifies immediate housing needs and military background.",
  },
  {
    num: "02",
    phase: "Phase 2",
    title: "Stabilization & Intake Plan",
    desc: "Resident arrives at campus, receives a semi-private room, hygiene kit, and warm meal, and completes a personalized 90-day reset goal plan with a case worker.",
  },
  {
    num: "03",
    phase: "Phase 3",
    title: "Housing & Reintegration Path",
    desc: "Resident moves through benefits filing, recovery workshops, and career coaching, then transitions into an independent permanent apartment with ongoing follow-up.",
  },
];

export const WHY_ISVRC = [
  { num: "01", title: "Safety", body: "A secure, controlled environment where a veteran can lower their guard and rest — the first requirement for any real recovery." },
  { num: "02", title: "Structure", body: "Predictable routine and clear expectations. Discipline isn't punishment here — it's the scaffolding that stability is built on." },
  { num: "03", title: "Dignity", body: "Veterans are treated as people rebuilding, not cases to process. Every interaction protects their respect." },
  { num: "04", title: "Accountability", body: "Clear goals, honest check-ins, and a shared commitment to forward progress. We show up, and we expect the same." },
  { num: "05", title: "Trauma-informed support", body: "Every part of the model is designed around how trauma actually works — patient, steady, and never re-traumatizing." },
];

export const STANDARD_CARDS = [
  { title: "Trauma-Informed Environment", desc: "A quiet, safe facility structured to reduce hypervigilance and sensory stress." },
  { title: "Peer-Driven Camaraderie", desc: "Shared living with fellow veterans fosters mutual trust and discipline." },
  { title: "Dedicated Case Managers", desc: "One-on-one guidance filing claims, budgeting, and securing leases." },
  { title: "Zero-Tolerance Safety", desc: "A 100% drug-, alcohol-, and weapon-free facility for total peace of mind." },
  { title: "Structured Daily Routine", desc: "Purposeful days built around recovery, responsibility, and forward momentum." },
  { title: "Dignity-First Culture", desc: "Respect is non-negotiable — every veteran is met as a person, not a case file." },
];

export const WHO_WE_SERVE = [
  { icon: "home", title: "Unsheltered Veterans", desc: "Immediate shelter placement for military veterans sleeping in vehicles, outdoors, or emergency night shelters." },
  { icon: "shield", title: "At-Risk Veterans", desc: "Prevention support for veterans facing imminent lease eviction, family displacement, or transitional distress." },
  { icon: "users", title: "VA & Referral Agencies", desc: "Direct, fast-track bed coordination for VA social workers, hospital discharge planners, and community partners." },
];

export const VALUES = ["Protection", "Dignity", "Structure", "Reintegration"];

export const FAQ_CATEGORIES = ["All Questions", "Eligibility", "Stay Length", "Rules & Safety", "Referrals", "Cost & Funding"];

export const FAQ = [
  { category: "Eligibility", q: "Who is eligible to stay at Iron Shield Reset Center?", a: "We serve military veterans (Army, Navy, Air Force, Marines, Coast Guard, Space Force, and Reserve/National Guard with active service) who are homeless or at immediate risk of homelessness. We accept honorable, general-under-honorable, and uncharacterized discharges. Discharge status can be reviewed case-by-case." },
  { category: "Stay Length", q: "How long can a veteran stay in the transitional housing program?", a: "This is transitional housing, so length of stay is tied to each veteran's stabilization plan — typically several months while a permanent housing path is built." },
  { category: "Cost & Funding", q: "Is there any cost for a veteran to enter the center?", a: "None. Iron Shield is a nonprofit program and our services are provided at no cost to eligible veterans, supported by donors and community partners." },
  { category: "Rules & Safety", q: "What are the rules and guidelines regarding sobriety and safety?", a: "Iron Shield maintains a 100% drug-, alcohol-, and weapon-free campus. Residents follow a structured daily routine and shared community standards designed to keep the environment calm, safe, and recovery-focused." },
  { category: "Referrals", q: "Can a family member, VA case manager, or agency refer a veteran?", a: "Yes. Family, friends, case managers, churches, hospitals, and agencies can all submit a referral. With the veteran's permission, we'll reach out directly." },
  { category: "Referrals", q: "What happens after I submit an intake form online?", a: "Our intake team reviews your submission and follows up — typically within one business day, and faster for urgent situations — with a short conversation to confirm needs and next steps." },
  { category: "Cost & Funding", q: "Do you help veterans secure permanent HUD-VASH or SSVF housing?", a: "Yes. Reintegration planning includes connecting veterans to permanent housing resources such as HUD-VASH and SSVF, coordinated alongside VA and community partners." },
  { category: "Rules & Safety", q: "What if a veteran is in immediate danger?", a: "Iron Shield is not an emergency service. If someone is in immediate danger, call 911. Veterans in crisis can call the Veterans Crisis Line: dial 988 then press 1, or text 838255." },
];

export const TESTIMONIALS = [
  {
    quote: "Iron Shield gave me a door that locked and people who actually showed up. For the first time in two years I could sleep — and then I could plan.",
    name: "Marcus T.",
    role: "U.S. Army veteran · now permanently housed",
  },
  {
    quote: "I refer veterans from our clinic and they're contacted within a day. The structure and follow-through are exactly what my patients need.",
    name: "Dana R., LCSW",
    role: "VA-affiliated case manager",
  },
  {
    quote: "My brother came back different. Iron Shield met him with dignity, not paperwork. He's working again and calls home every Sunday.",
    name: "Elena M.",
    role: "Family member of a resident",
  },
];

export const STATS = [
  { value: "340+", label: "Veterans Housed & Reset", note: "Since founding" },
  { value: "89%", label: "Permanent Housing Placement", note: "6-month post-discharge" },
  { value: "1,200+", label: "Case Management Hours", note: "Annually provided" },
  { value: "100%", label: "Drug & Alcohol Free", note: "Safe structured campus" },
];

export const CRISIS_RESOURCES = [
  { label: "Veterans Crisis Line", value: "Dial 988, then Press 1", note: "Or text 838255 — 24/7, confidential, free" },
  { label: "Emergency", value: "Call 911", note: "If you are in immediate danger" },
  { label: "National Call Center for Homeless Veterans", value: "1-877-424-3838", note: "1-877-4AID-VET — 24/7 free support" },
];

export const IMMEDIATE_NEEDS = [
  "Emergency shelter",
  "Food assistance",
  "Medical / mental health care",
  "Substance recovery support",
  "Benefits / VA navigation",
  "Employment help",
  "Transportation",
  "Clothing / essentials",
];

export const STORIES = [
  { name: "Marcus T.", branch: "U.S. Army", quote: "Iron Shield gave me a door that locked and people who showed up. I could finally sleep — then I could plan.", outcome: "Housed in 47 days · now employed full-time" },
  { name: "Ray D.", branch: "U.S. Marine Corps", quote: "The structure held me accountable without shame. My VA claim got filed and my benefits finally came through.", outcome: "Disability claim approved · stable housing" },
  { name: "James P.", branch: "U.S. Navy", quote: "I walked in with a trash bag of clothes. I walked out with a lease, a job, and a reason to keep going.", outcome: "Permanent lease · 12-month follow-up" },
];

export const PROGRAM_DETAILS = [
  { id: "transitional-housing", title: "Transitional Reset Housing", tagline: "Structured, safe residential shelter with 24/7 support", category: "Housing", iconName: "Home",
    description: "A clean, secure, alcohol- and drug-free residential facility offering semi-private accommodations, daily nutritious meals, laundry facilities, and round-the-clock staffing to help veterans stabilize from crisis.",
    highlights: ["Semi-private temperature-controlled rooms", "Nutritious meal program (3 daily meals + pantry access)", "Clean & secure environment with keycard access", "Communal gathering spaces & quiet study rooms", "On-site case manager office"],
    eligibility: "Honorably or General Discharge veterans experiencing homelessness or immediate housing instability. Clean toxicology screening upon entry.",
    lengthOfStay: "90 to 180 days (extendable based on goal progress)" },
  { id: "reset-wellness", title: "Reset & Recovery Support", tagline: "Trauma-informed mental health, peer mentorship & recovery", category: "Wellness", iconName: "HeartPulse",
    description: "Holistic stabilization incorporating peer-led support groups, trauma-informed wellness counseling, physical fitness activities, and stress management coaching designed for military transitions.",
    highlights: ["Weekly peer-to-peer veteran support circles", "Trauma-informed coping workshops", "Linkage to VA mental health services & counseling", "Fitness & outdoor wellness activities", "Relapse prevention planning"],
    eligibility: "All active residents enrolled in Iron Shield transitional housing.",
    lengthOfStay: "Continuous during residency" },
  { id: "benefits-navigation", title: "Benefits & VA Navigation", tagline: "Claim earned VA healthcare, disability & pensions", category: "Benefits", iconName: "FileText",
    description: "Expert guidance through complex federal, state, and nonprofit benefit systems. Accredited Veteran Service Officers help veterans file disability claims, enroll in VA healthcare, and secure state entitlements.",
    highlights: ["Disability compensation & pension claim filing", "VA healthcare enrollment & appointment transport", "Discharge upgrade assistance guidance", "HUD-VASH & SSVF housing voucher navigation", "DD-214 retrieval support"],
    eligibility: "Any veteran seeking housing assistance or enrolled in our programs.",
    lengthOfStay: "30 to 60 days focused navigation" },
  { id: "reintegration-career", title: "Reintegration & Career Pathway", tagline: "Job readiness, certifications & permanent housing placement", category: "Career", iconName: "Briefcase",
    description: "Focused skill-building to bridge military experience with sustainable civilian employment and independent housing. Includes resume building, interview practice, employer partnerships, and lease preparation.",
    highlights: ["Resume translation (military codes to civilian skills)", "Partnerships with local trades, logistics & IT employers", "Financial literacy, budgeting & credit repair coaching", "Permanent housing search & move-in grant support", "Post-discharge follow-up for 12 months"],
    eligibility: "Residents in Phase 2 & Phase 3 of the reset program.",
    lengthOfStay: "Integrated into final 90 days" },
];

export const RESOURCES = [
  { id: "res-1", title: "Veterans Crisis Line", category: "crisis", phone: "988 (Press 1)", website: "https://www.veteranscrisisline.net", description: "Free, confidential support 24/7 for veterans in crisis and their families.", isNational: true },
  { id: "res-2", title: "National Call Center for Homeless Veterans", category: "housing", phone: "1-877-424-3838", website: "https://www.va.gov/homeless/", description: "24/7 hotline connecting homeless veterans directly with VA shelter services and HUD-VASH housing voucher navigation.", isNational: true },
  { id: "res-3", title: "NC Division of Veterans Affairs", category: "va_benefits", phone: "(844) 624-8387", website: "https://www.milvets.nc.gov/", description: "North Carolina state benefit advisors for disability, education, and housing grants.", isNational: false },
  { id: "res-4", title: "VA Regional Medical Center — Durham & Winston-Salem", category: "va_benefits", phone: "(919) 286-0411", website: "https://www.va.gov/durham-health-care/", description: "Comprehensive VA healthcare, mental health clinics, and emergency medical care.", isNational: false },
  { id: "res-5", title: "Veterans Legal Assistance Project (NC Legal Aid)", category: "legal", phone: "(866) 219-5262", website: "https://www.legalaidnc.org/", description: "Free legal aid for eligible low-income veterans regarding discharge upgrades and eviction prevention.", isNational: false },
  { id: "res-6", title: "NCWorks Veteran Employment Services", category: "employment", phone: "(800) 562-6339", website: "https://www.ncworks.gov", description: "Priority employment placement services and trade training for North Carolina veterans.", isNational: false },
];

export const SITE = {
  name: "Iron Shield Veterans Reset Center",
  short: "Iron Shield",
  mission: "Structured transitional housing, stabilization, and recovery-centered guidance for homeless and at-risk veterans.",
  serviceArea: "Serving veterans across North Carolina",
  campus: "Winston-Salem · Triad Outreach Hub",
  region: "NC Region",
  ein: "Pending (application in progress)",
  email: "help@ironshieldvets.org",
  phone: "(919) 555-0142",
  hotline: "(800) 555-VETS",
  donateUrl: "#",
};
